import React from 'react';
import { motion } from 'framer-motion';
import { NewspaperIcon, TrendingUpIcon, UsersIcon, SparklesIcon } from 'lucide-react';
const updates = [{
  icon: UsersIcon,
  image: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20?w=600&q=80',
  title: 'Special Announcement: VIP Growing Fast',
  description: 'Our VIP community just hit 5K+ members. Thank you for the trust!',
  color: 'neon-purple'
}, {
  icon: SparklesIcon,
  image: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=600&q=80',
  title: 'New Betting Partners Added',
  description: "We've expanded our partnerships to include Paripesa alongside 1XBET and 1Win.",
  color: 'neon-cyan'
}, {
  icon: TrendingUpIcon,
  image: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=600&q=80',
  title: 'Free Daily Tips — Now More Detailed',
  description: "We've upgraded our prediction format for clarity and accuracy.",
  color: 'neon-green'
}];
export function LatestUpdates() {
  return <section id="updates" className="w-full py-16 px-4 bg-gradient-to-b from-dark-card to-dark-base" data-id="element-119">
      <div className="container mx-auto max-w-7xl" data-id="element-120">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-121">
          <div className="inline-flex items-center gap-2 bg-neon-cyan/10 px-4 py-2 rounded-full mb-4" data-id="element-122">
            <NewspaperIcon className="w-5 h-5 text-neon-cyan" data-id="element-123" />
            <span className="text-neon-cyan font-semibold text-sm" data-id="element-124">
              WHAT'S NEW
            </span>
          </div>

          <h2 className="text-2xl md:text-5xl font-black mb-4" data-id="element-125">
            <span className="text-gradient-cyan" data-id="element-126">
              Latest Updates from GreenHS
            </span>
          </h2>

          <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto" data-id="element-127">
            Stay informed about our latest announcements and improvements
          </p>
        </motion.div>

        {/* Updates Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-128">
          {updates.map((update, index) => {
          const Icon = update.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="group" data-id="element-129">
                <div className="relative bg-dark-card rounded-2xl overflow-hidden border border-gray-800 hover:border-neon-cyan/50 transition-all duration-300" data-id="element-130">
                  {/* Image */}
                  <div className="relative h-48 overflow-hidden" data-id="element-131">
                    <img src={update.image} alt={update.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-132" />
                    <div className="absolute inset-0 bg-gradient-to-t from-dark-card via-dark-card/50 to-transparent" data-id="element-133"></div>

                    {/* Icon Badge */}
                    <div className={`absolute top-4 right-4 w-12 h-12 bg-${update.color}/20 backdrop-blur-sm rounded-full flex items-center justify-center border border-${update.color}/30`} data-id="element-134">
                      <Icon className={`w-6 h-6 text-${update.color}`} data-id="element-135" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6" data-id="element-136">
                    <h3 className="text-lg md:text-xl font-bold mb-3 text-white group-hover:text-neon-cyan transition-colors" data-id="element-137">
                      {update.title}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-138">
                      {update.description}
                    </p>
                  </div>

                  {/* Hover Glow Effect */}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-139">
                    <div className="absolute inset-0 bg-gradient-to-t from-neon-cyan/5 to-transparent" data-id="element-140"></div>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}